/* label-text.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./label-text.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
var labelTextStyles = null;
export default function LabelText(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("span", {
    className: ax(["_nd5l11ig _1wpz1h6o"])
  }, children);
}